/**
 *
 *
 * @class MobileMenu
 */
class MobileMenu {
    /**
     * Creates an instance of MobileMenu.
     * @param {string} mobMenuClass
     * @param {string} activeClass
     * @param {string} openButtonClass
    //  * @param {string} closeButtonClass
     * @memberof MobileMenu
     */
    constructor(mobMenuClass, activeClass, openButtonClass) {
        this.mobMenuClass = mobMenuClass;
        this.mobMenu = document.querySelector(mobMenuClass);
        this.activeClass = activeClass;
        this.openButtonClass = openButtonClass;
        this.openButton = document.querySelector(openButtonClass);
        // this.closeButton = document.querySelector(closeButtonClass);
        this.secondLevelItemClass = '.mobile-menu__menu-item.has-child';
        this.thirdLevelItemClass = '.mobile-menu__child.has-child';
        this.init();
    }    

    // closeOnBackdropClick = e => {
    //     if (e.target !== this.mobMenu && !e.target.closest(`${this.mobMenuClass}.${this.activeClass}`) && !e.target.closest(this.openButtonClass)) this.closeMenu();
    // }

    openMenu = () => {
        if (document.querySelector('.top-banner')) document.querySelector('.top-banner').style.display = 'none';
        this.mobMenu.classList.add(this.activeClass);
        document.body.classList.add('lock');
        this.openButton.classList.add(this.activeClass);
        document.querySelector('.header').classList.add('mob-open');
        // document.addEventListener("click", this.closeOnBackdropClick);
    }

    closeMenu = () => {
        if (document.querySelector('.top-banner')) document.querySelector('.top-banner').style.display = 'block';
        this.mobMenu.classList.remove(this.activeClass);
        document.body.classList.remove('lock');
        this.openButton.classList.remove(this.activeClass);
        document.querySelector('.header').classList.remove('mob-open');
        // document.removeEventListener("click", this.closeOnBackdropClick);
    }

    toggleMenu = () => {
        if (this.mobMenu.classList.contains(this.activeClass)) this.closeMenu() 
        else this.openMenu();
    }

    init = () => {
        this.openButton.addEventListener("click", this.toggleMenu);
        // this.closeButton.addEventListener("click", this.closeMenu);   
        
        window.matchMedia('(max-width: 960px').addEventListener('change', e => {
            if (!e.matches) return;
            if (this.openButton) {
                this.openButton.addEventListener("click", this.toggleMenu);
            }
        })
    
        window.matchMedia('(min-width: 961px)').addEventListener('change', (e) => {
            if (!e.matches) return;
            if (this.openButton) {
                this.openButton.removeEventListener("click", this.toggleMenu);
                this.openMenu();
                enableScroll();
            }
        })

        this.mobMenu.addEventListener("click", e => {
            console.log(e.target.closest('.mobile-menu__grandchild'));

            if (e.target.closest('.mobile-menu__grandchild')) return;
                
            if (e.target.closest(this.thirdLevelItemClass)) {
                console.log(e.target);
                
                e.preventDefault();
                const target = e.target.closest(this.thirdLevelItemClass);
                
                if (target.classList.contains(this.activeClass)) {
                    target.classList.remove(this.activeClass);
                    return;
                }
                if (this.mobMenu.querySelector(`${this.thirdLevelItemClass}.${this.activeClass}`)) this.mobMenu.querySelector(`${this.thirdLevelItemClass}.${this.activeClass}`).classList.remove(this.activeClass);
                target.classList.add(this.activeClass);
                return;
            }

            if (e.target.closest(this.secondLevelItemClass)) {
                e.preventDefault();
                const target = e.target.closest(this.secondLevelItemClass);
                
                if (target.classList.contains(this.activeClass)) {
                    target.classList.remove(this.activeClass);
                    return;
                }
                if (this.mobMenu.querySelector(`${this.secondLevelItemClass}.${this.activeClass}`)) this.mobMenu.querySelector(`${this.secondLevelItemClass}.${this.activeClass}`).classList.remove(this.activeClass);
                target.classList.add(this.activeClass);
                return;
            }


        })
    }
}

new MobileMenu('.mobile-menu', 'active', '.header__hamburger')
const header = document.querySelector('.header');

if (document.querySelector('.header__menu-item.has-child')) {
    document.querySelector('.header').addEventListener("click", e => {

        if (e.target.closest('.header__menu-item.has-child')) {
            e.preventDefault();
            const target = e.target.closest('.header__menu-item.has-child');

            if (target.classList.contains('active')) {
                target.classList.remove('active');
                header.classList.remove('mega-menu-open');
                document.body.classList.remove('lock');
                return;
            }
            
            if (document.querySelector('.header__menu-item.has-child.active')) {
                document.querySelector('.header__menu-item.has-child.active').classList.remove('active');
            }

            // if (target.classList.contains('active')) return;
            target.classList.toggle('active');
            header.classList.toggle('mega-menu-open');
            document.body.classList.add('lock');
        }

        // if (e.target.closest('.mega-menu__parent-link.has-child')) {
        //     e.preventDefault();
        //     const target = e.target.closest('.mega-menu__col');
        //     if (target.classList.contains('active')) return;
        //     if (document.querySelector('.mega-menu__col.active')) document.querySelector('.mega-menu__col.active').classList.remove('active');
        //     target.classList.add('active');
        // }
    });

    document.addEventListener("click", e => {
        if (!e.target.closest('.mega-menu') && !e.target.closest('.header__nav') && document.querySelector('.header__menu-item.has-child.active')) {
            document.querySelector('.header__menu-item.has-child.active').classList.remove('active');
            header.classList.remove('mega-menu-open');
            document.body.classList.remove('lock');
        }
    })
}



const shuffleHovers = Array.from(document.querySelectorAll('[data-hover-shuffle]'));

if (shuffleHovers.length > 0) {

    const shuffleAnimation = (e) => {
        const target = e.currentTarget;

        if (target.dataset.animating) return;
        
        if (target.dataset.hoverShuffle === 'children') {
            target.dataset.animating = true;
            
            target.style.width = `${target.offsetWidth}px`;
            // target.style.paddingInline = '0px'

            const words = target.querySelectorAll('[data-hover-shuffle-child]');
            const originalWords = Array.from(words).map((word) => word.textContent);
    
            let shuffles = 0;
            const maxShuffles = 3;
            const intervalDuration = 300 / maxShuffles;

    
            let animationInterval = setInterval(() => {
                if (shuffles >= maxShuffles) {
                    clearInterval(animationInterval);
                    words.forEach((word, index) => {
                        word.textContent = originalWords[index]
                    })
    
                    delete target.dataset.animating;                   
                    target.style.width = ``;
                } else {

                    words.forEach(word => {
                        let shuffledText = word.textContent.split('').sort(() => Math.random() - 0.5)
                        .join('');

                        word.textContent = shuffledText;
                    })
                    shuffles++;
                }
            }, intervalDuration)
        }
    }

    // if (window.matchMedia('(min-width: 960px)').matches) {
    //     shuffleHovers.forEach(btn => {
    //         btn.addEventListener("mouseenter", shuffleAnimation);
    //     })
    // }
}
// End SHUFFLE HOVER ANIMATION



// --- POSTS SLIDER ---
const latestPosts = Array.from(document.querySelectorAll('.latest-posts'));
if (latestPosts.length > 0) {
    latestPosts.forEach(sl => {
        if (sl.querySelector('.swiper')) {
            new Swiper(sl.querySelector('.swiper'), {
                slidesPerView: 3.5,
                spaceBetween: 16,
                slidesPerGroup: 3,
                // loop: true,
                speed: 1000,
                pagination: {
                    el: sl.querySelector('.latest-posts__counter'),
                    type: 'fraction'
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2.2,
                        slidesPerGroup: 2
                    },
                    641: {
                        slidesPerView: 3.2,
                        slidesPerGroup: 3,
                    }, 
                    961: {
                        slidesPerView: 3.5,
                        slidesPerGroup: 3
                    }
                }
            })
        }
    })
}

// --- USER ENTRIES ---
if (document.querySelector('.user-nav--user')) {
    const userNav = document.querySelector('.user-nav--user');
    const mobileUserNav = document.querySelector('.mobile-menu__user-nav');

    fetch('https://app.viralsweep.com/api/entries/205031', {
        headers: {
            'x-api-key': 'f9924c2a3330970aecef85d3e96408adda49b53b7e883b11_52700u'
        }
    }).then(r => r.json())
    .then(r => {
        const { entries } = r;
        const currentUser = entries.find(u => u.email === userNav.dataset.email);
        if (currentUser) {
            const totalEntries = currentUser.entries_total;
            if (Number.parseInt(totalEntries) > 0) {
                if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `${totalEntries} entries`;
                if (mobileUserNav.querySelector('.user__entries'))  mobileUserNav.querySelector('.user__entries').textContent = `${totalEntries} entries`;
            } else {
                if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `0 entries`;
                if (mobileUserNav.querySelector('.user__entries')) mobileUserNav.querySelector('.user__entries').textContent = `0 entries`;
            }
        } else {
            if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `0 entries`;
            if (mobileUserNav.querySelector('.user__entries')) mobileUserNav.querySelector('.user__entries').textContent = `0 entries`;
        }
    }).catch(e => {
        console.log(e);
        if (userNav.querySelector('.user__entries')) userNav.querySelector('.user__entries').textContent = `0 entries`;
        if (mobileUserNav.querySelector('.user__entries')) mobileUserNav.querySelector('.user__entries').textContent = `0 entries`;
    })
}

// --- HERO SOUNTDOWN ---
if (document.querySelector('.hero')) {
    const hero = document.querySelector('.hero'); 
    const counter = hero.querySelector('.counter'); {
        if (counter && counter.dataset.countdown) {
            let futuredate = new Date(counter.dataset.countdown.replace(/\./g, "/"));
           
            if (!isNaN(futuredate)) {

                futuredate = futuredate.getTime();
                const outputHours = counter.querySelector('.counter__item--hours');
                const outputDays = counter.querySelector('.counter__item--days');
                const outputMinutes = counter.querySelector('.counter__item--minutes');
                const outputSeconds = counter.querySelector('.counter__item--seconds');

                function convertMs(ms) {
                    const second = 1000;
                    const minute = second * 60;
                    const hour = minute * 60;
                    const day = hour * 24;
                
                    const days = Math.floor(ms / day);
                    const hours = Math.floor((ms % day) / hour);
                    const minutes = Math.floor(((ms % day) % hour) / minute);
                    const seconds = Math.floor((((ms % day) % hour) % minute) / second);
                
                    return { days, hours, minutes, seconds };
                }
                
                const addLeadingZero = (value, amount = 2) => {
                    return value.toString().padStart(amount, "0");
                }

                const timerCalc = () => {
                    const timerId = setInterval(() => {
                        const currentDate = new Date().getTime();
                        const differenceInTime = convertMs(futuredate - currentDate);
                        
                        outputHours.textContent = addLeadingZero(differenceInTime.hours)
                        outputDays.textContent = addLeadingZero(differenceInTime.days, 3);
                        outputMinutes.textContent = addLeadingZero(differenceInTime.minutes);
                        outputSeconds.textContent = addLeadingZero(differenceInTime.seconds);
                    }, 1000);
                }

                timerCalc();

                // document.addEventListener("DOMContentLoaded", timerCalc)
            }
            
        }
    }
}

const params = new URLSearchParams(window.location.search);
const q = params.get('q');
if (q) {
  document.querySelector('.search-results-page__num').textContent = q;
}

if (document.getElementById('searchBtn')) {
    document.getElementById('searchBtn').addEventListener('click', () => {
        setTimeout(() => {
            document.getElementById('Search-In-Template').focus();
        }, 500);
    });
}

if (document.getElementById('Search-In-Template')) {
    document.getElementById('Search-In-Template').addEventListener('keyup', () => {
        document.getElementById('Search-In-Template').click();
        console.log('keyup')
    });
}

// copy coupon

 // Find all elements with the class 'coupon-block'
const couponBlocks = document.querySelectorAll('.coupon-block');

couponBlocks.forEach(block => {
    const originalText = block.querySelector('.coupon-block__txt').textContent;

    block.addEventListener('click', (event) => {
        const currentBlock = event.currentTarget;
        if (currentBlock.classList.contains('copied')) {
            return;
        }
        const textToCopy = currentBlock.dataset.copy;

        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy);

            const textSpan = currentBlock.querySelector('.coupon-block__txt');

            if (textSpan) {
                textSpan.textContent = 'Copied';
            }

            currentBlock.classList.add('copied');
            setTimeout(() => {
                if (textSpan) {
                    textSpan.textContent = originalText;
                }
                currentBlock.classList.remove('copied');
            }, 2000);
        }
    });
});


class CustomSelectManager {
  constructor(mainClass) {
    this.mainClass = mainClass; // e.g., '.custom-select'
    this.activeClass = 'active';

    this.chosenOptionSelector = '.custom-select__selected';
    this.headingSelector = '.custom-select__heading';
    this.listSelector = '.custom-select__dropdown';
    this.listItemSelector = `${this.listSelector} li`;
    
    this.priceMinSelector = '.price-range__input--min';
    this.priceMaxSelector = '.price-range__input--max';

    this.filterForm = document.getElementById('filter-form');

    this.init();
  }

  init() {
    document.addEventListener('click', this.handleClick);

    document.addEventListener('focus', this.handleFocus, true);
    
    document.addEventListener('blur', this.handleBlur, true);
  }

  handleClick = (e) => {
    const target = e.target;
    const selectWrapper = target.closest(this.mainClass);

    if (target.closest(this.headingSelector) && selectWrapper) {
      this.toggleDropdown(selectWrapper);
      return;
    }

    if (target.closest(this.listItemSelector) && selectWrapper) {
      this.selectItem(selectWrapper, target.closest('li'));
      return;
    }

    if (!selectWrapper) {
      this.closeAllDropdowns();
    }
  }

  handleFocus = (e) => {
    const target = e.target;
    if (target.matches(this.priceMinSelector) || target.matches(this.priceMaxSelector)) {
      target.dataset.prevValue = target.value;
    }
  }

  handleBlur = (e) => {
    const target = e.target;
    const prevValue = target.dataset.prevValue;

    if ((target.matches(this.priceMinSelector) || target.matches(this.priceMaxSelector)) && prevValue !== undefined) {
      if (target.value !== prevValue) {
        if (this.filterForm) {
          this.filterForm.submit();
        }
      }
      delete target.dataset.prevValue;
    }
  }

  toggleDropdown(selectWrapper) {
    const isActive = selectWrapper.classList.contains(this.activeClass);
    
    this.closeAllDropdowns(selectWrapper);

    if (isActive) {
      selectWrapper.classList.remove(this.activeClass);
    } else {
      selectWrapper.classList.add(this.activeClass);
    }
  }

  closeDropdown(selectWrapper) {
    selectWrapper.classList.remove(this.activeClass);
  }

  closeAllDropdowns(excludeElement = null) {
    const activeSelects = document.querySelectorAll(`${this.mainClass}.${this.activeClass}`);
    activeSelects.forEach(select => {
      if (select !== excludeElement) {
        this.closeDropdown(select);
      }
    });
  }

  selectItem(selectWrapper, liElement) {


    const chosenOption = selectWrapper.querySelector(this.chosenOptionSelector);
    if (chosenOption) {
      chosenOption.textContent = liElement.textContent.trim();
      chosenOption.classList.add(this.activeClass); // Mark as selected
    }

    this.closeDropdown(selectWrapper);

    console.log(chosenOption);
    

    const input = selectWrapper.querySelector('input');
    if (input) {
      input.value = liElement.dataset.value;
      if (liElement.dataset.optionValueId) input.dataset.optionValueId = liElement.dataset.optionValueId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (this.filterForm) {
      this.filterForm.submit();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomSelectManager('.custom-select');
});

// -- AUTH

// class Toggler {
//     constructor(toggleBlock, pageState, selector) {
//       this.toggleMode = toggleBlock;
//       this.state = 'left';
//       this.pageState = pageState;
//       this.pageSelector = selector;
//     }
//     setState(newState, pageNewState) {
//       this.toggleMode.classList.remove(this.state);
//       this.state = newState;
//       this.toggleMode.classList.add(newState);
//       document.querySelector(`${this.pageSelector}${this.pageState}`).classList.add('hide');
//       this.pageState = pageNewState;
//       document.querySelector(`${this.pageSelector}${pageNewState}`).classList.remove('hide');
//     }
//     init() {
//       this.toggleMode.addEventListener('click', (e) => {
//         if (
//           !e.target.classList.contains(`[data-toggler="${this.state}"]`) &&
//           !e.target.closest(`[data-toggler="${this.state}"]`) &&
//           e.target.classList.contains('toggle-mode__selection')
//         ) {
//           this.setState(e.target.dataset.toggler, e.target.dataset.page);
//         }
//       });
//     }
//   }
//   const autToggler = document.querySelector('.toggle-mode--auth');

//   if (autToggler) {
//     new Toggler(autToggler, 'sign-up', '.auth__content--').init();
//     const resetLink = document.querySelector('.reset-link');
//     resetLink.addEventListener('click', (e) => {
//       e.preventDefault();
//       autToggler.classList.add('hide');
//       Array.from(document.querySelectorAll('.auth__content')).forEach((c) => c.classList.add('hide'));
//       document.querySelector('.auth__content--reset').classList.remove('hide');
//       document.querySelector('#resetPassword').addEventListener('submit', (e) => {
//         e.preventDefault();
//         document.querySelector('.auth__content--reset').classList.add('hide');
//         document.querySelector('.auth__content--sent').classList.remove('hide');
//       });
//     });

//     const userToggler = document.querySelector('.toggle-mode--user');
//     if (userToggler) {
//       new Toggler(userToggler, 'account', '.user-frame__content--').init();
//     }
// }
// // End TOGGLE MODES

// const editBtns = Array.from(document.querySelectorAll('.account__edit-btn'));
// if (editBtns.length > 0) {
// editBtns.forEach((btn) => {
//   btn.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.target.closest('.account__block').classList.toggle('editable');
//   });
// });
// }
// const oddAccountBtns = Array.from(document.querySelectorAll('.account__btn'));
// if (oddAccountBtns.length > 0) {
// oddAccountBtns.forEach((btn) => [
//   btn.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.target.closest('.account__block').classList.toggle('updatable');
//   }),
// ]);
// }
// Array.from(document.querySelectorAll('.account__back-btn')).forEach((cancelbtn) =>
// cancelbtn.addEventListener('click', (e) => {
//   e.preventDefault();
//   e.target.closest('.account__block').classList.remove('editable', 'updatable');
// })
// );
// End ACCOUNT



// document.querySelector('#customer_login').addEventListener("submit", e => {
//     e.preventDefault();
// })